module.exports = __webpack_public_path__ + "static/media/gf.742c8a0b.png";